// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"326": "36cc9d4e7ebb629d","531": "586a4a3ee3888b18","566": "8969a57306d5a422","605": "b46dee19af49e997","762": "228ccfee72fdefa0","98": "916156348c5f7e7f",}[chunkId] + ".js"
}